import type { SelectProps } from "@mantine/core";

import styles from "./logBarSelectStyles.module.scss";

export const logBarSelectStyles: SelectProps["styles"] = {
  input: {
    backgroundColor: "var(--mantine-color-inputBackgroud-0)",
    borderColor: "var(--mantine-color-inputBorder-0)",
    color: "var(--mantine-color-text-0)",
  },
  dropdown: {
    backgroundColor: "var(--mantine-color-inputBackgroud-0)",
    borderColor: "var(--mantine-color-inputBorder-0)",
  },
  section: {
    color: "var(--mantine-color-text-0)",
  },
};

export const logBarSelectClassNames: SelectProps["classNames"] = {
  option: styles.selectOption,
};

export const logBarSelectComboboxProps: SelectProps["comboboxProps"] = {
  withinPortal: true,
  zIndex: 1000,
};
